var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDomain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.234,
    height: 43.234,
    viewBox: "0 0 43.234 43.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "algorithm",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M211.487,304a3.487,3.487,0,1,0,3.487,3.487A3.491,3.491,0,0,0,211.487,304Zm0,5.579a2.092,2.092,0,1,1,2.092-2.092A2.095,2.095,0,0,1,211.487,309.579Zm0,0",
    transform: "translate(-189.87 -277.502)",
    fill: "#1a8fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M240,32h5.579v1.395H240Zm0,0",
    transform: "translate(-219.081 -29.211)",
    fill: "#1a8fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M240,64h5.579v1.395H240Zm0,0",
    transform: "translate(-219.081 -58.421)",
    fill: "#1a8fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M192,96h9.763v1.395H192Zm0,0",
    transform: "translate(-175.265 -87.632)",
    fill: "#1a8fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M192,128h9.763v1.395H192Zm0,0",
    transform: "translate(-175.265 -116.843)",
    fill: "#1a8fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M192,160h9.763v1.395H192Zm0,0",
    transform: "translate(-175.265 -146.053)",
    fill: "#1a8fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M43.234,22.315V16.736H33.471v5.579h4.184v6.973H29.287v-1.2l-1.712-.571.807-1.614L25.7,23.22l-1.614.808-.57-1.713h-1.2V18.131h6.973V9.763h8.368v3.9l-1.6-1.6-.986.986,3.282,3.282,3.282-3.282-.986-.986-1.6,1.6V8.368H29.287V0H18.539L13.946,4.593V8.368H4.184v5.29l-1.6-1.6-.986.986,3.282,3.282,3.282-3.282-.986-.986-1.6,1.6v-3.9h8.368v8.368h6.973v4.184h-1.2l-.57,1.713-1.614-.808L14.851,25.9l.807,1.614-1.712.571v1.2H5.578V22.315H9.762V16.736H0v5.579H4.184V33.571a2.789,2.789,0,1,0,1.395,0V30.682H9.762v8.5a2.092,2.092,0,1,0,1.395,0v-8.5h2.789v1.2l1.712.571-.807,1.614,2.683,2.683,1.614-.808.57,1.713h3.794l.57-1.713,1.614.808,2.683-2.683-.807-1.614,1.713-.571v-1.2h2.789v8.5a2.092,2.092,0,1,0,1.395,0v-8.5h4.184v2.888a2.789,2.789,0,1,0,1.395,0V22.315ZM18.13,2.381v1.8h-1.8Zm-2.789,3.2h4.184V1.395h8.368V16.736H15.341ZM1.394,18.131H8.368V20.92H1.394ZM6.276,36.261a1.395,1.395,0,1,1-1.395-1.395A1.4,1.4,0,0,1,6.276,36.261ZM10.46,41.84a.7.7,0,1,1,.7-.7A.7.7,0,0,1,10.46,41.84ZM27.893,30.877l-1.6.534-.118.307c-.035.089-.07.178-.108.264l-.135.3.754,1.508-1.262,1.262L23.916,34.3l-.3.135c-.086.038-.173.073-.261.107l-.311.117-.534,1.6H20.724l-.534-1.6-.311-.117c-.089-.034-.176-.068-.262-.107l-.3-.135-1.508.754-1.262-1.262.754-1.508-.135-.3c-.039-.087-.073-.175-.108-.264l-.118-.307-1.6-.534V29.093l1.6-.534.118-.307c.035-.089.07-.178.108-.265l.135-.3-.754-1.508,1.262-1.262,1.508.754.3-.135c.086-.038.173-.073.261-.107l.311-.117.534-1.6h1.784l.534,1.6.311.117c.089.034.176.068.261.107l.3.135,1.508-.754,1.262,1.262-.754,1.508.135.3c.039.087.073.175.108.264l.118.307,1.6.534ZM32.774,41.84a.7.7,0,1,1,.7-.7A.7.7,0,0,1,32.774,41.84Zm6.973-5.579a1.395,1.395,0,1,1-1.395-1.395A1.4,1.4,0,0,1,39.747,36.261ZM34.866,18.131h6.973V20.92H34.866Zm0,0",
    fill: "#1a8fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomain);
export default __webpack_public_path__ + "static/media/domain.1e12b12546aa955024b95b989205ad6d.svg";
export { ForwardRef as ReactComponent };